import React from 'react';
import styled from '@emotion/styled';

const Container = styled.div`
  height: 80px;
  width: 80px;
  position: relative;
`;

const Path = styled.path`
  fill: #cecece;
`;

const OuterRing = styled.div`
  width: 80px;
  height: 80px;
  position: absolute;
  top: 0;
  left: 0;
  animation: spin-clockwise 5000ms linear infinite;

  @keyframes spin-clockwise {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

const InnerRing = styled.div`
  width: 45px;
  height: 45px;
  position: absolute;
  top: 22%;
  left: 23%;
  animation: spin-counter-clockwise 5000ms linear infinite;

  @keyframes spin-counter-clockwise {
    0% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
`;

interface Props {
  testIdentifier?: string;
}

export const ChartLoadingIcon = (props: Props) => {
  return (
    <Container data-testid={props.testIdentifier}>
      <OuterRing>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 38.19 37.81">
          <g id="Layer_2" data-name="Layer 2">
            <Path
              d="M11.71,30.27a13.35,13.35,0,0,1-2.63-2.18L5,31.6A18.63,18.63,0,0,0,9,35Z"
              transform="translate(-0.01 -0.04)"
            />
            <Path
              d="M16.8,37.72l.46-5.39A13.08,13.08,0,0,1,12.86,31l-2.68,4.7A19,19,0,0,0,16.8,37.72Z"
              transform="translate(-0.01 -0.04)"
            />
            <Path
              d="M29.14,28A13.65,13.65,0,0,1,23,31.83a14.13,14.13,0,0,1-4,.61h-.46l-.46,5.39a18.75,18.75,0,0,0,6.46-.8,19.1,19.1,0,0,0,8.71-5.54Z"
              transform="translate(-0.01 -0.04)"
            />
            <Path
              d="M37.28,24.57a20.06,20.06,0,0,0,.92-5.24H32.77a12.66,12.66,0,0,1-.57,3.36Z"
              transform="translate(-0.01 -0.04)"
            />
            <Path
              d="M32.16,14.79A15.65,15.65,0,0,1,32.73,18h5.43a20.48,20.48,0,0,0-.8-4.78,17.59,17.59,0,0,0-.73-2l-4.89,2.33A9.14,9.14,0,0,1,32.16,14.79Z"
              transform="translate(-0.01 -0.04)"
            />
            <Path
              d="M22.07,5.43a13,13,0,0,1,3.44,1.3,13.49,13.49,0,0,1,5.62,5.62L36,10A19.32,19.32,0,0,0,23,0Z"
              transform="translate(-0.01 -0.04)"
            />
            <Path
              d="M7,12.31l.46-.8L3,8.43c-.27.42-.54.88-.8,1.34A19,19,0,0,0,1,24.69l5-1.87A13.55,13.55,0,0,1,7,12.31Z"
              transform="translate(-0.01 -0.04)"
            />
            <Path
              d="M12.78,6.57a12,12,0,0,1,2.29-.92L16,5.43,15,.08c-.5.11-1,.23-1.53.38A21.38,21.38,0,0,0,10,1.87Z"
              transform="translate(-0.01 -0.04)"
            />
            <Path
              d="M8.24,10.36A14.52,14.52,0,0,1,11.6,7.23L8.89,2.56a18.76,18.76,0,0,0-5.12,4.7Z"
              transform="translate(-0.01 -0.04)"
            />
          </g>
        </svg>
      </OuterRing>
      <InnerRing>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24.28 24.28">
          <Path
            d="M27.73,21.13l3,1.07a11.87,11.87,0,0,0,.5-2.83H28A13,13,0,0,1,27.73,21.13Z"
            transform="translate(-6.95 -6.61)"
          />
          <Path
            d="M29.75,24.43a4.69,4.69,0,0,0,.46-1l-3-1.07c-.08.19-.19.38-.27.57a8.13,8.13,0,0,1-.61,1l2.45,2A7.61,7.61,0,0,0,29.75,24.43Z"
            transform="translate(-6.95 -6.61)"
          />
          <Path
            d="M25.51,25a9.15,9.15,0,0,1-3.82,2.33,8.56,8.56,0,0,1-2.6.38h0l-.27,3.17a12.08,12.08,0,0,0,3.86-.54A12.57,12.57,0,0,0,28,27Z"
            transform="translate(-6.95 -6.61)"
          />
          <Path
            d="M20,9.82l.54-3.13c-.46,0-.92-.08-1.38-.08a9.49,9.49,0,0,0-1.54.08l.57,3.13A13.49,13.49,0,0,1,20,9.82Z"
            transform="translate(-6.95 -6.61)"
          />
          <Path
            d="M15.19,10.7a7.6,7.6,0,0,1,1.3-.5l.34-.11L16.26,7c-.23.08-.5.11-.73.19a9.84,9.84,0,0,0-2,.8Z"
            transform="translate(-6.95 -6.61)"
          />
          <Path
            d="M21.27,10a10.16,10.16,0,0,1,2,.8,8.66,8.66,0,0,1,3.55,3.48L29.71,13a11.93,11.93,0,0,0-4.93-4.9,12.21,12.21,0,0,0-3-1.11Z"
            transform="translate(-6.95 -6.61)"
          />
          <Path
            d="M11.18,14.52c.08-.11.11-.23.19-.34l-2.6-1.75c-.11.23-.27.42-.38.65a12.09,12.09,0,0,0-.92,9.21h0l3-1.11A8.89,8.89,0,0,1,11.18,14.52Z"
            transform="translate(-6.95 -6.61)"
          />
          <Path
            d="M12.71,25,10.3,27.1a11.56,11.56,0,0,0,2.22,1.83l1.57-2.75A6.85,6.85,0,0,1,12.71,25Z"
            transform="translate(-6.95 -6.61)"
          />
          <Path
            d="M9.38,26.06,11.79,24a7.56,7.56,0,0,1-.88-1.57L8,23.58A14.57,14.57,0,0,0,9.38,26.06Z"
            transform="translate(-6.95 -6.61)"
          />
        </svg>
      </InnerRing>
    </Container>
  );
};

export default ChartLoadingIcon;
